'use client';

import log from 'loglevel';
import { QuickLinksSection } from './components/QuickLinksSection';
import {
	CONTACT_SECTION_TYPE_ID,
	ACCORDION_SECTION_TYPE_ID,
	QUICK_LINKS_SECTION_TYPE_ID,
	CALL_TO_ACTION_SECTION_TYPE_ID,
	TEXT_SECTION_TYPE_ID,
	HIGHLIGHT_SECTION_TYPE_ID,
	CARD_SECTION_TYPE_ID,
	IFRAME_SECTION_TYPE_ID,
	AIRLINE_SECTION_TYPE_ID,
	FEATURE_ENTRYPOINT_TYPE_ID,
	IMAGE_SECTION_TYPE_ID,
	NEWS_SECTION_TYPE_ID,
	COLUMN_SECTION_TYPE_ID,
	CAROUSEL_SECTION_TYPE_ID,
	POLICIES_SECTION_TYPE_ID,
} from '../../../contentful/constants';
import { IPageSectionEntry } from '../../../contentful/types';
import ContactSection from './components/ContactSection';
import { AccordionSection } from './components/AccordionSection';
import { CallToActionSection } from './components/CallToActionSection';
import { TextSection } from './components/TextSection';
import HighlightSection from './components/HighlightSection';
import { CardSection } from './components/CardSection';
import { IframeSection } from './components/IFrameSection';
import { ImageSection } from './components/ImageSection';
import NewsSection from './components/NewsSection';
import ColumnSection from './components/ColumnSection';
import CarouselSection from './components/CarouselSection';
import PoliciesSection from './components/PoliciesSection';

interface IProps {
	id: string;
	section: IPageSectionEntry;
}

export function SectionComponent({ id, section }: IProps) {
	switch (section.contentType) {
		case QUICK_LINKS_SECTION_TYPE_ID:
			return <QuickLinksSection section={section} key={section.id} id={id} />;

		case ACCORDION_SECTION_TYPE_ID:
			return <AccordionSection section={section} key={section.id} id={id} />;

		case CALL_TO_ACTION_SECTION_TYPE_ID:
			return <CallToActionSection section={section} key={section.id} id={id} />;

		case CONTACT_SECTION_TYPE_ID:
			return <ContactSection section={section} key={section.id} id={id} />;

		case AIRLINE_SECTION_TYPE_ID:
			return <ContactSection section={section} key={section.id} id={id} />;

		case TEXT_SECTION_TYPE_ID:
			return <TextSection section={section} key={section.id} id={id} />;

		case HIGHLIGHT_SECTION_TYPE_ID:
			return <HighlightSection section={section} key={section.id} id={id} />;

		case CARD_SECTION_TYPE_ID:
			return <CardSection section={section} key={section.id} id={id} />;

		case IFRAME_SECTION_TYPE_ID:
			return <IframeSection section={section} key={section.id} id={id} />;

		case FEATURE_ENTRYPOINT_TYPE_ID:
			return <CardSection section={section} key={section.id} id={id} />;

		case IMAGE_SECTION_TYPE_ID:
			return <ImageSection section={section} key={section.id} id={id} />;

		case NEWS_SECTION_TYPE_ID:
			return <NewsSection section={section} key={section.id} id={id} />;

		case COLUMN_SECTION_TYPE_ID:
			return <ColumnSection section={section} key={section.id} id={id} />;

		case CAROUSEL_SECTION_TYPE_ID:
			return <CarouselSection section={section} key={section.id} id={id} />;

		case POLICIES_SECTION_TYPE_ID:
			return <PoliciesSection section={section} key={section.id} id={id} />;

		default:
			const invalidSection = section;

			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			log.error(`Unknown content type: ${(invalidSection as any).contentType}`);
	}

	return null;
}
